var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Translate } from "../../I18N";
import { Icon } from "../../UI";
import { attachmentCompleted } from "../../Metadata/actions/supportingFilesActions";
import { uploadAttachment, uploadAttachmentFromUrl } from "../actions/actions";
import { AttachmentsModal } from "./AttachmentsModal";











function mapStateToProps({ attachments }) {
  return {
    progress: attachments.progress
  };
}

const mapDispatchToProps = (dispatch) =>
bindActionCreators({ attachmentCompleted }, dispatch);

const connector = connect(mapStateToProps, mapDispatchToProps);

const UploadSupportingFile = (props) => {
  const { entitySharedId, storeKey, progress, model = '' } = props;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => setModalOpen(true);
  const closeModal = () => {
    setModalOpen(false);
    props.attachmentCompleted(entitySharedId);
  };

  const getPercentage = progress.get(entitySharedId);

  useEffect(() => {
    if (getPercentage === 100) {
      closeModal();
    }
  }, [progress]);

  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    _jsx("button", { type: "button", onClick: openModal, className: "btn attachments-modal-trigger" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "plus" }), "\xA0", /*#__PURE__*/

    _jsx(Translate, {}, void 0, "Add file")
    ), /*#__PURE__*/

    _jsx(AttachmentsModal, {
      isOpen: modalOpen,
      onClose: closeModal,
      entitySharedId: entitySharedId,
      storeKey: storeKey,
      getPercentage: getPercentage,
      model: model,
      uploadAttachment: props.uploadAttachment || uploadAttachment,
      uploadAttachmentFromUrl: props.uploadAttachmentFromUrl || uploadAttachmentFromUrl }
    )
    ));

};

export { mapDispatchToProps, mapStateToProps };
export default connector(UploadSupportingFile);